<template>
  <div class="container inicio">
    <div class="header">
      <!-- Botones de navegacion  -->
    </div>
    <div class="section">
      <div class="logo">
        <figure>
          <img src="../assets/logo.png" alt="DIRECTV">
        </figure>
      </div>
        <b-button class="link"
          @click.prevent="iniciar">Cargá tus datos aquí!</b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Inicio',
  data () {
    return {
    }
  },
  methods: {
    iniciar () {
      if (this.$store.getters['user/loggedIn']) {
        this.$router.push({ name: 'SeleccionEvento' });
      } else {
        this.$router.push({ name: 'Login' });
      }
      //this.$router.push({ name: 'SeleccionEvento' });
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Inicio.vue